/**
 * UAがエノテカアプリか
 */
export const isEnotecaApp = (userAgent?: string): boolean => !!userAgent?.includes('ENOTECA');
